export const generalStateSelector = state => state.general
